import styles from './style.module.scss';

export const UIDivider = () => {
  return <div className={styles.root}></div>;
};
